import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { withRouter } from "react-router-dom";
import s from "./styles.scss";
import { Container, Row, Col, Button } from "reactstrap";
import {
  infoNotification,
  successNotification
} from "../../../utils/notifications";
import { downloadPrecalculo } from "../../actions/reports";
import { MemoTable } from "./Precalculo.table";
import { PrecalculoStore } from "../../containers/precalculo/Precalculo.store";
import { PrecalculoDispatcher } from "../../containers/precalculo/Precalculo.dispatcher";
import FormBuilder from "../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Buttons, formConfig, Inputs } from "./Precalculo.form";
import IButtonBuilder from "../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

interface Props extends PrecalculoStore, PrecalculoDispatcher {}

interface State {
  wait: boolean;
}

const PAGE_SIZE = 10;
const meses = {
  1: "Enero",
  2: "Febrero",
  3: "Marzo",
  4: "Abril",
  5: "Mayo",
  6: "Junio",
  7: "Julio",
  8: "Agosto",
  9: "Septiembre",
  10: "Octubre",
  11: "Noviembre",
  12: "Diciembre"
};

class PrecalculoPage extends React.Component<Props, State> {
  state = {
    wait: false
  };

  componentDidMount() {
    this.loadHistorial();
  }

  loadHistorial = () => {
    this.props.getHistorialReporteSimulacion(0, PAGE_SIZE);
  };

  submit = values => {
    const { mes, anio } = values;
    this.setState({ wait: true });

    infoNotification("Descargando reporte...");
    downloadPrecalculo(anio, mes, meses[mes], () => {
      this.setState({ wait: false });
    });
  };

  generarSimulacion = async () => {
    const preview = await this.props.postReporteSimulacionCierre();

    if (preview) {
      this.loadHistorial();
    }
  };

  handleFetchData = (state: any) => {
    const page = state.page || 0;
    const size = state.pageSize || 10;
    this.props.getHistorialReporteSimulacion(page, size);
  };

  render() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;

    return (
      <Container className="mt-3 mb-3 p-0">
        {/* Formulario */}
        <div style={{ margin: "0 15px" }}>
          <FormBuilder<Inputs, Buttons>
            config={formConfig}
            processing={this.state.wait || this.props.postingSimulacionCierre}
            submit={this.submit}
            init={{
              mes: currentMonth.toString(),
              anio: currentYear
            }}
          >
            <IButtonBuilder
              name="simulacion"
              onClick={this.generarSimulacion}
            />
          </FormBuilder>
        </div>

        {/* Tabla de Historial */}
        <Row className="mt-5">
          <Col>
            <h5>Historial de Reportes de Simulación de Cierre</h5>
            <p className="text-muted">
              Los reportes se envían por correo al finalizar.
            </p>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <MemoTable
              page={this.props.historialSimulacionCierre}
              loading={this.props.loadingHistorialSimulacion}
              onFetchData={this.handleFetchData}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withRouter(withStyles(s)(PrecalculoPage));
